module.exports = __webpack_public_path__ + "static/media/close-icon.f4f59156.svg";